import { useEffect } from 'react';
import { initializeWebSocket } from '../lib/websocket';
import { IChatUser } from '../interfaces/chat/chat.interface';
import { IEchoInstance } from '../interfaces/chat/websocket.interface';

export const useRealtimeUsers = (
  setUsers: React.Dispatch<React.SetStateAction<IChatUser[]>>,
  currentUserId: number | null,
  enabled: boolean = true,
) => {
  useEffect(() => {
    if (!enabled || !currentUserId) return;

    let cleanup: (() => void) | undefined;

    const setupWebSocket = async () => {
      try {
        const echo: IEchoInstance | null = await initializeWebSocket();
        if (!echo) return;

        const channel = echo.private('chat.users');

        channel.listen('.user.status.changed', (payload: unknown) => {
          const payloadData = payload as { id: number; is_online: boolean };
          if (payloadData.id !== currentUserId) {
            setUsers((prev) =>
              prev.map((user) =>
                user.id === payloadData.id ? { ...user, isOnline: payloadData.is_online } : user,
              ),
            );
          }
        });

        cleanup = () => {
          try {
            channel.stopListening('.user.status.changed');
          } catch (error) {
            // Erro ao limpar WebSocket
          }
        };
      } catch (error) {
        // Erro ao configurar WebSocket
      }
    };

    setupWebSocket();

    return () => {
      if (cleanup) {
        cleanup();
      }
    };
  }, [enabled, currentUserId, setUsers]);
};

